<ng-template
  #modalRef
  let-modal
>
  <div class="modal-header">
    <div>
      <div class="d-flex">
        <h4
          translate
          class="modal-title"
        >
          {{ modalTitle }}
        </h4>

        @if (keyOfferings) {
          <h4 class="modal-title">({{ keyOfferings.length }})</h4>
        }
      </div>
    </div>
    <button
      type="button"
      class="btn-close close"
      aria-label="Close"
      aria-describedby="modal-title"
      (click)="modal.dismiss()"
    >
      <span aria-hidden="true"> &times; </span>
    </button>
  </div>

  <div class="modal-body modal-body-minspace">
    @if (!!keyOfferings.length) {
      <ul class="modal-list">
        @for (key of keyOfferings; track $index) {
          <li class="modal-line">
            {{ key.description }}
          </li>
        }
      </ul>
    } @else {
      <span
        class="message-empty"
        translate
      ></span>
    }

    <ng-template #emptyKeyOfferMsg>
      <span
        class="message-empty"
        translate
      ></span>
    </ng-template>
  </div>
</ng-template>
